import { render, staticRenderFns } from "./_slotsMain.vue?vue&type=template&id=6307fef2&lang=pug&"
import script from "./_slotsMain.vue?vue&type=script&lang=js&"
export * from "./_slotsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports